import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af40bfee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(":")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ zero: _ctx.isZero })
  }, [
    _createElementVNode("span", null, [
      _createVNode(_component_q_icon, {
        name: "timer",
        size: "xs",
        class: "q-mr-xs"
      })
    ]),
    _createElementVNode("span", null, _toDisplayString(_ctx.timer.hours), 1),
    _hoisted_1,
    _createElementVNode("span", null, _toDisplayString(_ctx.timer.minutes), 1),
    _hoisted_2,
    _createElementVNode("span", null, _toDisplayString(_ctx.timer.seconds), 1)
  ], 2))
}